import { UserManager } from "oidc-client-ts";
// Change by ML {} put in brackets for V4
import { jwtDecode } from 'jwt-decode';

// read from the Vite‐provided env
const AUTHORITY = import.meta.env.VITE_AUTHORITY;
const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
const SCOPE = import.meta.env.VITE_SCOPE;

// compute your callback URLs based on the current origin
const ORIGIN = window.location.origin;
const REDIRECT = `${ORIGIN}/callback`;
const LOGOUT = `${ORIGIN}/signout-callback`;

export const oidcConfig = {
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  redirect_uri: REDIRECT,
  response_type: "code",
  scope: SCOPE,
  post_logout_redirect_uri: LOGOUT,

  // keep your silent renew settings:
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
};

// ✅ Only ONE instance created here
export const mgr = new UserManager(oidcConfig);

// ML AccessRights 13/08/2024
mgr.events.addUserLoaded(user => {
  const payload = jwtDecode(user.id_token);
  console.log("[OIDC] Raw ID token payload:", payload);

  const perm = payload.perm;
  const perms = Array.isArray(perm) ? perm : perm ? [perm] : [];
  console.log("[OIDC] Extracted perm claims:", perms);

  localStorage.setItem('claims', JSON.stringify(perms));
  console.log("[OIDC] localStorage.claims now:", localStorage.getItem('claims'));
});

// ✅ Export the same instance under the old name for compatibility
export const userManager = mgr;

userManager.events.addAccessTokenExpired(() =>
  userManager.signinSilent().catch(console.error)
);
userManager.events.addSilentRenewError(err =>
  console.error("Silent renew failed", err)
);
userManager.events.addUserSignedOut(() =>
  console.log("User signed out remotely")
);
